'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('settings-edit', {
      url: '/admin/settings/edit/:id',
      template: '<settings-edit></settings-edit>',
      params:{id:null},
      authenticate: 'superadmin'
    });
}



// WEBPACK FOOTER //
// ./client/~ap/app/settings/edit/settings-edit.routes.js